import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 6l0 13" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 6l0 13" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 6l0 13" })
	]
});
export { SvgBook as ReactComponent };
